module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p3.f69c3185.png";